import AspectRatioIcon from '@mui/icons-material/AspectRatio';
import { styled } from '@mui/material';
import { useRecoilState } from 'recoil';
import { Orientations } from '~/engine/view/views/PlaneView';
import { viewportOrientationOrderState } from '~/state/atoms/viewerAtoms';

const ViewportSwapToMain = styled(AspectRatioIcon)`
    color: ${({ theme }) => theme.palette.text.primary};
    cursor: pointer;
    pointer-events: auto;
`;

interface SwapToMainProps {
    viewportOrientation: string;
}

const SwapToMain = ({ viewportOrientation }: SwapToMainProps) => {
    const [viewportOrientationOrder, setViewportOrientationOrder] =
        useRecoilState(viewportOrientationOrderState);

    const handleViewportOrientationOrderChange = (orientation: string) => {
        const swapElements = (
            arr: Orientations[],
            pos1: number,
            pos2: number
        ) => {
            const temp = arr[pos1];
            arr[pos1] = arr[pos2];
            arr[pos2] = temp;
            return arr;
        };
        // the index can be either 1 or 2, since the main view is always at index 0
        const orientationIdx = viewportOrientationOrder.findIndex(
            (viewportOrientation) => viewportOrientation === orientation
        );
        const newViewportOrientationOrder: Orientations[] = swapElements(
            [...viewportOrientationOrder],
            0,
            orientationIdx
        );
        setViewportOrientationOrder(newViewportOrientationOrder);
    };

    return (
        <ViewportSwapToMain
            onClick={() =>
                handleViewportOrientationOrderChange(viewportOrientation)
            }
            data-testid="swapToMainIcon"
        />
    );
};

export default SwapToMain;
